import React from "react";
import { data } from "./data";
import "./styles.scss";

const RolesSection = () => {
  return (
    <div className="mlp-roles-wrapper">
      {data.map((role, index) => {
        return (
          <div
            className="mlp-role-container"
            style={{ backgroundImage: `url(${role.image})` }}
          >
            <div className="role-card">
              <h2 className="role-card-title" dangerouslySetInnerHTML={{ __html:role.title }}/>
              <p className="role-card-desc" dangerouslySetInnerHTML={{ __html:role.desc }}/>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default RolesSection;
